import React, { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { notifyError, notifySuccess } from "../../utils/functions";
// import countryCodes from "../Home/countryCodes.json";
import "./index.scss";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    // phone: "",
    // countryCode: "+1",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Reset error for the field
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // const phoneRegex = /^[0-9]{7,15}$/;

    if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!emailRegex.test(formData.email))
      newErrors.email = "Invalid email format";
    // if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    // else if (!phoneRegex.test(formData.phone))
    //   newErrors.phone = "Invalid phone number format";
    if (!formData.subject.trim()) newErrors.subject = "Subject is required";
    if (!formData.message.trim()) newErrors.message = "Message is required";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/inquiry`;
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          name: formData.fullName,
          email: formData.email,
          // phone: `${formData.countryCode}${formData.phone}`,
          subject: formData.subject,
          message: formData.message,
        }),
      });

      if (!response.ok) {
        throw new Error("Submission failed! Check credentials.");
      }

      const data = await response.json();
      notifySuccess(data.message);
    } catch (error) {
      notifyError(error?.message || "Failed to submit inquiry.");
    } finally {
      setLoading(false);
    }
    // Reset form
    setFormData({
      fullName: "",
      email: "",
      // phone: "",
      // countryCode: "+1",
      subject: "",
      message: "",
    });
    setErrors({});
  };

  return (
    <>
      <Header />

      <section className="contact-us-page">
        <h2>Contact us</h2>
        <form className="contact-us-form" onSubmit={handleSubmit} noValidate>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name*"
            value={formData.fullName}
            onChange={handleChange}
          />
          {errors.fullName && (
            <small className="error">{errors.fullName}</small>
          )}

          <input
            type="email"
            name="email"
            placeholder="Email*"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <small className="error">{errors.email}</small>}

          {/* <div className="phone-group">
            <select
              name="countryCode"
              value={formData.countryCode}
              onChange={handleChange}
            >
              {countryCodes.map((item) => (
                <option key={item.code} value={item.code}>
                  {item.short} ({item.code})
                </option>
              ))}
            </select>
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number*"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          {errors.phone && <small className="error">{errors.phone}</small>} */}

          <input
            type="text"
            name="subject"
            placeholder="Subject*"
            value={formData.subject}
            onChange={handleChange}
          />
          {errors.subject && <small className="error">{errors.subject}</small>}

          <textarea
            name="message"
            placeholder="Your Message*"
            rows="4"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          {errors.message && <small className="error">{errors.message}</small>}

          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </section>

      <Footer />
    </>
  );
};

export default ContactUs;
